module.exports = __webpack_public_path__ + "static/media/call.47415645.svg";